import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { formatApiError } from "../lib/api";
import { WakzyLogo } from "../components/WakzyLogo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Lock } from "lucide-react";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome, ${user.name}`);
      if (user.role === "customer") navigate("/kiosk");
      else navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center hero-bg stripe-overlay px-6">
      <div className="w-full max-w-md fade-up">
        <div className="text-center mb-8 logo-glow">
          <WakzyLogo className="h-16 mx-auto" />
        </div>
        <div className="gradient-border" style={{ borderRadius: "12px" }}>
          <div className="gradient-border-inner p-8" style={{ borderRadius: "11px", background: "rgba(11,19,36,0.88)", backdropFilter: "blur(20px)" }}>
            <div className="brand-divider mb-4">
              <span className="dot" />
              <span className="label-eyebrow" style={{ color: "var(--wakzy-gold)" }}>Wakzy DealerOS</span>
              <span className="dot" />
            </div>
            <h2 className="font-heading text-3xl mb-6 chrome-text">Sign in to continue</h2>
            <form onSubmit={onSubmit} className="space-y-4">
              <div>
                <Label className="text-sm text-slate-300">Email</Label>
                <Input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="bg-[#04060d] border-white/10 mt-1 h-11"
                  data-testid="login-email-input"
                />
              </div>
              <div>
                <Label className="text-sm text-slate-300">Password</Label>
                <Input
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="bg-[#04060d] border-white/10 mt-1 h-11"
                  data-testid="login-password-input"
                />
              </div>
              <Button
                type="submit"
                disabled={loading}
                className="btn-cta w-full h-11 rounded-sm mt-2"
                data-testid="login-submit-btn"
              >
                <Lock className="w-4 h-4 mr-2" />
                {loading ? "Signing in…" : "Sign In"}
              </Button>
            </form>
            <div className="text-xs text-slate-500 mt-6 text-center">
              <Link to="/" className="hover:text-slate-300" data-testid="login-back-link">
                Return to home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
